<template>
  <div class="mainElemetManagementContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="addEditElement({isAdd: true})" v-if="null !== addPermission" class="addBtn">
          {{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
                style="cursor: pointer"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
       <el-table-column
          prop="iconUrl"
          label="图元"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template  slot-scope="scope">
            <el-image
              style="height: 40px"
              :src="/minio/ + scope.row.iconUrl"
              fit="contain" />
          </template>
        </el-table-column>
        <el-table-column 
          prop="iconName"
          label="图元名称"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="attributeName"
          label="图元属性"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        >
          <!-- <template  slot-scope="scope">
            <el-select v-model="scope.row.attribute" placeholder="请选择图元属性">
              <el-option
                v-for="item in attributeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="type"
          label="禁用/启用"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              active-color="#FFA63E"
              inactive-color="#C1C1C1"
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              disabled
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                  <el-button
                    v-if="button.path === 'elementList-edit'"
                    @click="addEditElement({isAdd: false, row: { ... scope.row }})"
                    icon="el-icon-operte-view"
                    class="editBtn"
                    style="margin-right: 10px"
                  >{{ button.name }}</el-button>
                  <el-button
                    v-else-if="button.path === 'elementList-del'"
                    @click="deleteElement(scope.row)"
                    icon="el-icon-operte-view"
                    class="delBtn"
                    style="margin-right: 10px"
                  >{{ button.name }}</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;"
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        />
      </div>
    </div>

    <!-- 添加 编辑 模态框 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
      class="commonDialog"
      @close="cancelButtonCancelAddElement('commonForm')"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item label="图元名称" prop="iconName" class="left-form-item">
          <el-input
            v-model="commonForm.iconName"
            maxlength="50"
            placeholder="请输入图元名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="图元属性" prop="attribute" label-width="100px">
          <el-select
            v-model="commonForm.attribute"
            placeholder="请选择图元属性"
            popper-class="adminHomeSelect"
            @change="handleElementStatusChange('attribute')"
            clearable
          >
            <el-option
              v-for="attribute in attributeList"
              :key="attribute.value"
              :label="attribute.label"
              :value="attribute.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="status" label-width="100px">
          <el-select
            v-model="commonForm.status"
            placeholder="请选择启用状态"
            popper-class="adminHomeSelect"
            @change="handleElementStatusChange('status')"
            clearable
          >
            <el-option
              v-for="status in statuses"
              :key="status.value"
              :label="status.label"
              :value="status.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图元" :prop=" isEdit ? '' : 'pic'" label-width="100px" class="iconElement">
            <el-upload
              class="element-uploader"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleElementPicChange"
            >
              <img v-if="imageUrl" :src="imageUrl" class="element-image">
              <div v-else class="element-uploader-box">
                <div class="element-uploader-position">
                  <i class="el-icon-upload element-uploader-icon"></i>
                  <span class="element-uploader-text">点击上传图元</span>
                </div>
              </div>
            </el-upload>
        </el-form-item>
        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submitButtonAddEditElement('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="cancelButtonCancelAddElement('commonForm')" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { deepCopy } from '@/utils/tools.js'

export default {
  name: 'elemetManagement',
  props: ["menuId"],
  data() {
    return {
      // 添加按钮权限
      addPermission: null,
      // 其它按钮权限列表
      buttonList: [],
      // 搜索
      queryForm: {
        name: ''
      },
      // 存储图元表格数据
      tableData: [],
      // 图元属性 字典数据
      attributeList: [
        {
          value: 1,
          label: '无人机图标-UAV'
        },
        {
          value: 2,
          label: '驻点图标-STAY'
        },
        {
          value: 3,
          label: '站点图标-STATION'
        },
        {
          value: 4,
          label: '机场图标-AIRPORT'
        }
      ],
      // 图元状态 字典数据
      statuses: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 0,
          label: '否'
        }
      ],
      // 模态框 title
      title: '添加',
      // 控制 模态框 显示隐藏
      dialogVisible: false,
      // 存储表单信息
      commonForm: {},
      // 表单验证
      rules: {
        iconName: [{ required: true, trigger: "blur", message: "图元名称不能为空~" }],
        attribute: [{ required: true, trigger: "blur", message: "图元属性不能为空~" }],
        status: [{ required: true, trigger: "blur", message: "图元状态不能为空~" }],
        pic: [{ required: true, trigger: "blur", message: "图元不能为空~" }]
      },
      // 判断模态框是 添加 还是 编辑
      isEdit: false,
      // 记录 编辑状态时，编辑前的 图元属性
      commonFormAttribute: '',
      // 模态框 图元 图片url
      imageUrl: '',
      // 当前页数
      current: 1,
      // 显示条数
      size: 6,
      // 总条数
      totalCount: 0
    }
  },
  created() {
    this.query()
    this.buttonList = [];
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  mounted() {
    this.setGutterWidth();
  },
  methods: {
    // 配置 增-删-改 按钮权限回调函数
    getButtonList(buttonList) {
      // let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "elementList-add") {
              this.addPermission = child;
            } else if (child.path !== "elementList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    // 分页函数 - 每页显示条数改变触发的事件
    handleSizeChange(val) {
      this.size = val;
      this.query();
    },
    // 搜索图元信息 - 分页函数 - 页码改变触发的事件
    handleCurrentChange(current) {
      this.current = current;
      this.query();
    },
    // 查询 获取 图元信息
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/icon/queryIcon.do?pagesize=" +
        this.$data.size +
        "&currentpage=" +
        this.$data.current +
        "&keyword=" + 
        this.queryForm.name
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    // 删除按钮事件
    deleteElement(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
        this.$confirm(tips, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          cancelButtonClass: "cancel-style",
        })
        .then(() => {
          this.doDel(deepCopy(row.id));
        })
        .catch(() => {});
    },
    // 删除图元执行事件
    doDel(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/icon/deleteIcon.do?id=" + id)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
            this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    // 增加 编辑 图元
    addEditElement({ isAdd = false, row = {}} = {}) {
      if (isAdd) {
        this.isEdit = false
        this.title = "添加"
        this.commonForm = {
          pic: ''
        }
        this.$data.imageUrl = ''
      } else {
        this.title = "编辑"
        this.isEdit = true
        this.commonForm = row
        this.commonFormAttribute = row.attribute
        this.imageUrl = '/minio/' + row.iconUrl
      }
      this.dialogVisible = true;
    },
    // 编辑模态框 是否启用 状态改变处理事件
    handleElementStatusChange(type) {
      this.postJsonRequest("/basic-info-server/icon/changeIconStatus.do", deepCopy(this.commonForm))
        .then(res => {
          res = res.data
          console.log(res)
          if (!res.data && type === 'status') {
            this.commonForm.status = 0
            let msg = "已存在开启的同一属性图元，请重新选择启用状态！";
           
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          } else if (!res.data && type === 'attribute') {
            this.commonForm.attribute = this.commonFormAttribute
            let msg = "此属性已存在开启的其它图元，请重新选择图元属性！";
            
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
    },
    // 上传图元图片改变时执行的事件
    handleElementPicChange(file) {
      const isJPGPNG = file.type === 'image/jpeg' || 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPGPNG) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片只能是 JPG 或 png 格式!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }
      if (!isLt1M) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片大小不能超过 1MB!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }

      if (isJPGPNG && isLt1M) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.commonForm.pic = file.raw
        this.commonForm.iconUrl = ''
      }
    },
    // 添加图元 编辑图元
    submitButtonAddEditElement(ref) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          if (!this.isEdit) {
            this.addElementModel()
          } else {
            this.editElementModel()
          }
        }
      })
    },
    // 添加 图元信息 执行事件
    addElementModel() {
      let vue = this;
      const multiData = this.formatSubmitData(deepCopy(this.commonForm))
      this.postJsonRequest(
        "/basic-info-server/icon/addIcon.do",
        multiData
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    // 编辑 图元信息 执行事件
    editElementModel() {
      let vue = this;
      const multiData = this.formatSubmitData(deepCopy(this.commonForm))
      this.postJsonRequest(
        "/basic-info-server/icon/updateIcon.do",
        multiData
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "编辑成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    formatSubmitData(commonForms) {
      const formData = new FormData();
      const commonForm = commonForms;
      for (const key in commonForm) {
        if (commonForm.hasOwnProperty(key)) {
          const element = commonForm[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      return formData;
    },
    // 取消关闭按钮事件  重置表单
    cancelButtonCancelAddElement(ref) {
      this.dialogVisible = false
      this.$refs[ref].resetFields()
    }
  }
}
</script>

<style>
  .mainElemetManagementContainer {
    width: 100%;
    height: 100%;
  }

  .mainTableContainer
  .el-tabs
  .el-tabs__content
  #pane-stationList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 260px) !important;
}

.darkAdminHomeContainer .el-tabs .el-tabs__content .commonDialog .el-dialog .el-dialog__body .el-form .iconElement {
  height: 150px;
}

.iconElement .element-uploader .el-upload {
    background: rgba( 96, 98, 102, .3);
    width: 100%;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.iconElement .element-uploader .el-upload:hover {
    border-color: #409EFF;
}
.iconElement .element-uploader-box {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 150px;
    text-align: center;
    position: relative;
}
.iconElement .element-uploader-box .element-uploader-position {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.iconElement .element-uploader-box .element-uploader-position .element-uploader-icon {
    display: block;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
}
.iconElement .element-uploader-box .element-uploader-position .element-uploader-text {
    display: block;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
}
.iconElement .el-upload {
  height: 150px;
  position: relative;
}
.iconElement .el-upload .element-image {
    position: absolute; 
    height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* 定位 模态框 图元未上传时 提示信息位置 */
.iconElement > .el-form-item__content > .el-form-item__error {
  top: 440% !important;
}

/* 定位 确定 取消 按钮位置 */
.darkAdminHomeContainer .el-tabs .el-tabs__content .commonDialog .el-dialog .el-dialog__body
.el-form .el-form-item.formItemBtnRow, .darkAdminHomeContainer .el-tabs .el-tabs__content
.commonComplexDialog .el-dialog .el-dialog__body .el-form .el-form-item.formItemBtnRow {
  margin-top: 70px;
}



/* .mainTableContainer .el-input__inner {
  background: transparent;
  border: 1px solid transparent;
  color: #fff;
  font-size: 14px;
  outline: none;
}
.el-select-dropdown {
  background: rgba(0, 131, 253, .1);
  border: 1px solid rgba(0, 131, 253, .1);
}
.el-select-dropdown__item {
  background: rgba(0, 131, 253, .1);
  font-size: 14px;
}
.el-select-dropdown__item:hover {
  background: rgba(0, 131, 253, .1);
  color: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/components/admin/management/elementManagement.vue